import { Route, Routes } from "react-router-dom";

import { SwapsPage } from "./pages/SwapsPage";

export const SwapsNavigation = () => {
  return (
    <Routes>
      <Route path="/" element={<SwapsPage />} />
    </Routes>
  );
};
